import { apiUrl } from "../../ApiManager/AxiosHeaders"; // adjust path if needed

export const dailyReportingApi = {
  getDashboard: (params = {}) => apiUrl.get("daily-reporting/dashboard", { params }),

  getEmployeeReport: (id, params = {}) => apiUrl.get(`daily-reporting/employee/${id}`, { params }),
};